// header fixed on scroll
$(document).ready(function () {
  $(".my-cart").click(function () {
    updateCartDrawer();
    $(".cart-box").addClass("cart-display");
  });
  $(".cart-box .fa-times").click(function () {
    $(".cart-box").removeClass("cart-display");
  });

  $(".tab-menu-open").click(function () {
    $(".nav-menu").addClass("tab-menu-display");
    $(".nav-menu").removeClass("nav-menu-none");
    $("body").addClass("sm-body-scrollbar");
    //document.querySelector(".color-overlay").style.display = "block";
  });

  $(".cross-icon").click(function () {
    $(".nav-menu").addClass("nav-menu-none");
    $(".nav-menu").removeClass("tab-menu-display");
    $("body").removeClass("sm-body-scrollbar");
    //document.querySelector(".color-overlay").style.display = "none";
  });
  
  $(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
      $("#scroll").fadeIn();
    } else {
      $("#scroll").fadeOut();
    }
  });
  $("#scroll").click(function () {
    $("html, body").animate({ scrollTop: 0 }, 600);
    return false;
  });
  $(".searchbar").click(function () {
        document.getElementById("searchBlockSmall").style.width = "100%";
        var overlay = jQuery('<div id="overlay"> </div>');

        overlay.appendTo('.page-container');
        $("#searchBlockSmall").css('z-index','22333');
  });
  $(document).mouseup(function(e) 
{
    var container = $(".cart-box,.my-cart");

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) 
    {
        $(".cart-box").removeClass("cart-display");
    }
});
//---- Add overlay effect for mobile search box -----------   
//   setTimeout(function() {
//     console.log("Adding---");
//     if($('.fast-simon-form').length){
//       $('.searchbar').on('click',function(){
//         var overlay = jQuery('<div id="overlay"> </div>');
//         overlay.appendTo('.page-container');
//       }).keyup(function (e) {
//         if (e.which == 27) {
//           $('#overlay').remove();
//         }
//       }).blur(function (e) {
//         $('#overlay').remove();
//       });
//     }
//     $('body').click(function (e) {
//       if (!$(e.target).is('.searchbar')) {
//         $('#overlay').remove();
//       }
//     })
//   }, 7000);

  /*---- carousel css - To Fix overlap text issue when click next & previous slide---   */
  $('.carousel').on('slide.bs.carousel', function () {
   $('.carousel-control').addClass('disabled');
  });

  $('.carousel').on('slid.bs.carousel', function () {
    $('.carousel-control').removeClass('disabled');
  });
});

// search open block
function openNav() {
  document.getElementById("searchBlock").style.width = "100%";
}

function closeNav() {
  document.getElementById("searchBlockSmall").style.width = "0";
  document.getElementById("searchBlock").style.width = "0";
  $('#overlay').remove();
}

//quantity counter code
$(document).on("click", ".ajax-cart-item__minus-quantity", function (e) {
  decrementValue(e);
});
$(document).on("click", ".ajax-cart-item__add-quantity", function (e) {
  incrementValue(e);
});
function incrementValue(e) {
  e.preventDefault();
  var fieldName = $(e.target).data("field");
  var parent = $(e.target).closest("div");
  var linenumber = parent.attr("data-line");
  var currentVal = parseInt(parent.find(".ajax-cart-item__input-quantity").val(), 10);
  if (!isNaN(currentVal)) {
    parent.find(".ajax-cart-item__input-quantity").val(currentVal + 1);
  } else {
    parent.find(".ajax-cart-item__input-quantity").val(0);
  }
}
function decrementValue(e) {
  e.preventDefault();
  var fieldName = $(e.target).data("field");
  var parent = $(e.target).closest("div");
  var currentVal = parseInt(parent.find(".ajax-cart-item__input-quantity").val(), 10);
  var linenumber = parent.attr("data-line");
  if (!isNaN(currentVal) && currentVal > 0) {
    parent.find(".ajax-cart-item__input-quantity").val(currentVal - 1);
  } else {
    parent.find(".ajax-cart-item__input-quantity").val(0);
  }
}

$(document).ready(function () {
  $(".accordion-button").click(function () {
    $(this).addClass("Hello");
    $(this).toggleClass("bluecolor");
  });
});

// filter for mobile device
function openFilter() {
  document.getElementById("filterOption").style.width = "100%";
}

function closeFilter() {
  document.getElementById("filterOption").style.width = "0";
}

//BWP QTY send

function getVariantById(data, id) {
  return data.filter(
      function(data){ return data.id == id }
  );
}

document.addEventListener("DOMContentLoaded", function() {
  const getQuantity = () => {  
    return document.querySelector("input[name='quantity']");  
  };  
  function triggerUpdate (){
      let quantityInput = document.querySelector("input[name='quantity']").value;
      let selectedVariant = getVariantById(meta.product.variants,$("input[name='id']").val());
      let dataSKu = selectedVariant[0].sku;
      let variantSkus = [];
      window.bwp.updateWidget(dataSKu, quantityInput, variantSkus);
  }
  let inputQuantity = getQuantity();
  inputQuantity.addEventListener('input',triggerUpdate);

  var upQty = document.querySelector(".quantity-up");
  upQty.addEventListener('click',function(){
    setTimeout(triggerUpdate,100);
  });

  var downQty = document.querySelector(".quantity-down");
  downQty.addEventListener('click',function(){
    setTimeout(triggerUpdate,100);
  });
  
});
